export const PRE_CALL_SMS_DEFAULT_MINUTES = 5;
export const PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME = 'there';
export const PRE_CALL_SMS_FALLBACK_AGENT_NAME = 'Customer Service';
